import { Component, Input } from '@angular/core';
import { STATUS_INDICATOR } from '@app/shared/enum/status';

@Component({
    selector: 'app-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    standalone: false,
})
export class StatusIndicatorComponent {
    @Input() type?: STATUS_INDICATOR;
    @Input() state?: string;
}
